import {memo, PropTypes, shapeComponent, ShapeComponent, StyleSheet, Text, View} from "shared/base"
import React, {createContext} from "react"
import {digs} from "diggerize"
import {HelperText} from "react-native-paper"
import useInput from "@kaspernj/api-maker/build/use-input"

const ChalkyLayoutInputContainerContext = createContext(null)

const styles = StyleSheet.create({
  text: {marginBottom: 5, color: "#2c2c96", fontWeight: 500}
})

export {ChalkyLayoutInputContainerContext}

export default memo(shapeComponent(class ComponentsChalkyLayoutInputContainer extends ShapeComponent {
  static propTypes = {
    children: PropTypes.node
  }

  setup() {
    const {wrapperOpts} = useInput({props: this.props, wrapperOptions: {type: "input"}})
    const {errors, label} = digs(wrapperOpts, "errors", "label")

    this.setInstance({errors, label})
  }

  render() {
    const {errors, label} = this.tt
    const {children, rightOfLabel} = this.props

    return (
      <ChalkyLayoutInputContainerContext.Provider value="withinChalkyLayoutInputContainer">
        <View>
          {label &&
            <View style={{flexDirection: "row"}}>
              <Text style={styles.text}>
                {label}
              </Text>
              {rightOfLabel &&
                <View style={{marginLeft: "auto"}}>
                  {rightOfLabel}
                </View>
              }
            </View>
          }
          <View>
            {children}
          </View>
        </View>
        {errors.length > 0 &&
          <HelperText dataSet={this.helperTextDataSet ||= {class: "errors-helper-text"}} type="error">
            {this.errorMessages().join(". ")}
          </HelperText>
        }
      </ChalkyLayoutInputContainerContext.Provider>
    )
  }

  errorMessages() {
    const {errors} = this.tt
    const errorMessages = []

    for (const error of errors) {
      for (const errorMessage of error.getErrorMessages()) {
        errorMessages.push(errorMessage)
      }
    }

    return errorMessages
  }
}))
